export default __webpack_public_path__ + "media/join-game2x.43806ecb.png";